import { render, staticRenderFns } from "./delete-project-modal.vue?vue&type=template&id=3974c1dc&"
import script from "./delete-project-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-project-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports